import React from 'react';
import { FaBuilding, FaLayerGroup } from 'react-icons/fa';
import PropertySummaryPanel from './PropertySummaryPanel';
import PropertyFloorsTab from './PropertyFloorsTab';

const INNER_TABS = [
  { id: 'detail', label: 'Detail', icon: FaBuilding },
  { id: 'floors', label: 'Floors', icon: FaLayerGroup },
];

function PropertyWorkspacePane({
  property,
  innerTab,
  onInnerTabChange,
  selectedUnitId,
  onSelectUnit,
}) {
  if (!property) {
    return null;
  }

  const navigateToFloors = unitId => {
    if (unitId) {
      onSelectUnit?.(unitId);
    }
    onInnerTabChange?.('floors');
  };

  return (
    <div className='re-property-pane'>
      <nav className='re-inner-tabs' aria-label={`${property.name} sections`}>
        {INNER_TABS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            type='button'
            className={`re-inner-tab${innerTab === id ? ' active' : ''}`}
            onClick={() => onInnerTabChange(id)}
          >
            <Icon />
            {label}
          </button>
        ))}
      </nav>
      <div className='re-property-pane__body'>
        {innerTab === 'floors' ? (
          <PropertyFloorsTab
            property={property}
            selectedUnitId={selectedUnitId}
            onSelectUnit={onSelectUnit}
          />
        ) : (
          <PropertySummaryPanel
            property={property}
            onNavigateToFloors={navigateToFloors}
          />
        )}
      </div>
    </div>
  );
}

export default PropertyWorkspacePane;
